const FOLD_SUGAR_KM = 6371;
const radian = (fok: number) => (fok * Math.PI) / 180;

/** Haversine, Föld-sugár 6371 km; pontosan a `korzet_tavolsag_km` SQL-függvény képlete (supabase/migrations/20261027120000_iroda_korzet.sql). */
export function tavolsagKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const h = Math.sin(radian(lat2 - lat1) / 2) ** 2
    + Math.cos(radian(lat1)) * Math.cos(radian(lat2)) * Math.sin(radian(lon2 - lon1) / 2) ** 2;
  return 2 * FOLD_SUGAR_KM * Math.asin(Math.min(1, Math.sqrt(h)));
}

/**
 * Az iroda körzetében van-e a terület; az SQL `korzet_tartalmaz` sorrendjével: nincs körzet → igen; kézi kivétel
 * (`be` / `ki`) előbbre való a távolságnál; koordináta nélküli terület → igen (adathiánynál nem veszítünk leadet);
 * egyébként a távolság legfeljebb a sugár.
 */
export function korzetenBelul(
  terulet: { kod: string; lat: number | null; lon: number | null },
  korzet: { lat: number; lon: number; sugarKm: number } | null,
  kivetelek: Readonly<Record<string, 'be' | 'ki'>>,
): boolean {
  if (!korzet) return true;
  const kivetel = kivetelek[terulet.kod];
  if (kivetel === 'be') return true;
  if (kivetel === 'ki') return false;
  if (terulet.lat === null || terulet.lon === null) return true;
  return tavolsagKm(korzet.lat, korzet.lon, terulet.lat, terulet.lon) <= korzet.sugarKm;
}
